import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { CUSTOM_ICON_TYPE, Crumb } from '@shared/models';
import { DeviceService } from '@shared/services';
import { IconModule } from '@spartacus/storefront';
import { SdvorNavigationArrowComponent } from '../navigation-arrow';

@Component({
  selector: 'sd-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  imports: [AsyncPipe, RouterLink, SdvorNavigationArrowComponent, IconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SdvorBreadcrumbComponent implements OnChanges {
  @Input() crumbs?: Crumb[];
  mobileCrumb: Crumb | undefined;
  @ViewChild('mobileLink', { read: ElementRef }) mobileLink: ElementRef | undefined;
  public iconType = CUSTOM_ICON_TYPE;

  constructor(public deviceService: DeviceService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.crumbs && changes.crumbs.previousValue !== changes.crumbs.currentValue) {
      this.mobileCrumb = this.crumbs[this.crumbs.length - 2];
      this.mobileLink?.nativeElement?.blur();
    }
  }
}
